import {socketBroker,tcpBroker} from "../system/global";

export const alpha_server_ws = {
  url:socketBroker,
  clientId:'web/9001031',
  username:'hainan',
  password:'123456'
}

export const rc_server_ws = {
  url:socketBroker,
  clientId:'web/9001031',
  username:'hainan',
  password:'123456'
}

export const alpha_server_mqtt = {
  url:tcpBroker,
  clientId:'web/9001031',
  username:'hainan',
  password:'123456'
}

export const rc_server_mqtt = {
  url:tcpBroker,
  clientId:'web/9001031',
  username:'hainan',
  password:'123456'
}

export default alpha_server_ws;
